import { createLogger } from '@fabric-app/utils/logging';
import { createReadStream } from '@todesktop/client-fs';

const logger = createLogger("getToDesktopStreamChunk");
const getToDesktopStreamChunk = async (toDesktopStream, fileSize, fileType, chunkIndex, chunkSize) => {
  const start = chunkIndex * chunkSize;
  const end = Math.min(start + chunkSize - 1, fileSize);
  const stream = await createReadStream(toDesktopStream.dir, toDesktopStream.path, {
    ...toDesktopStream.options,
    start,
    end
  });
  const reader = await stream.getReader();
  const chunks = [];
  while (true) {
    const { value, done } = await reader.read();
    if (value) {
      chunks.push(value);
    }
    if (done) break;
  }
  const chunkBlob = new Blob(chunks, {
    type: fileType
  });
  logger.info(`Chunk ${chunkIndex} size: ${chunkBlob.size}`);
  return chunkBlob;
};

export { getToDesktopStreamChunk };
//# sourceMappingURL=getToDesktopStreamChunk.js.map
